import { render, staticRenderFns } from "./AreaEdit.vue?vue&type=template&id=580c52a3"
import script from "./AreaEdit.vue?vue&type=script&lang=js"
export * from "./AreaEdit.vue?vue&type=script&lang=js"
import style0 from "./AreaEdit.vue?vue&type=style&index=0&id=580c52a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports